import { ModelFactory } from "../../ModelFactory";

export class Role {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly displayName: string,
    public readonly isDefault: boolean,
  ) {
  }
}

class RoleFactory extends ModelFactory<Role> {
  protected fromJson(json: any): Role {
    return new Role(
      json['id'],
      json['name'],
      json['display_name'],
      json['is_default'] ?? false,
    );
  }
}
export const roleFactory = new RoleFactory();
